<template>
	<div class="sa">
		<v-expansion-panels v-model="aperti" multiple flat class="sa-panels">
			<v-expansion-panel v-for="s in script" :key="s.key" class="sa-panel">
				<v-expansion-panel-header class="sa-header">
					<div class="d-flex align-center">
						<v-icon small color="primary" class="mr-2">{{ s.icona }}</v-icon>
						<span class="sa-title">{{ s.label }}</span>
						<v-chip x-small label :color="pieno(s.key) ? 'success' : undefined" :outlined="!pieno(s.key)" class="ml-2">{{ pieno(s.key) ? 'Impostato' : 'Vuoto' }}</v-chip>
					</div>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<div class="sa-help">{{ s.quando }}</div>
					<div v-if="s.variabili.length" class="sa-vars">
						Variabili:
						<code v-for="v in s.variabili" :key="v" class="sa-var">{{ graffe(v) }}</code>
					</div>
					<v-textarea v-model="form.layout.script[s.key]" :placeholder="s.esempio" outlined dense auto-grow rows="3" hide-details class="sa-code" />
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</div>
</template>

<script>
// script di terze parti del sito pubblico: uno per momento (pagine, carrello, acquisto...), ognuno nel suo pannello
export default {
	name: 'ScriptAzioni',
	props: {
		form: { type: Object, required: true },
	},
	data() {
		return {
			aperti: [],
			script: [
				{
					key: 'header',
					label: 'Header',
					icona: 'mdi-page-layout-header',
					quando: 'Iniettato nel <head> di tutte le pagine. Utile per Google Tag Manager, Meta Pixel e simili.',
					variabili: [],
					esempio: '',
				},
				{
					key: 'footer',
					label: 'Footer',
					icona: 'mdi-page-layout-footer',
					quando: 'Iniettato prima della chiusura del <body>. Utile per chat, widget e script di terze parti.',
					variabili: [],
					esempio: '',
				},
				{
					key: 'addtocart',
					label: 'Aggiungi al carrello',
					icona: 'mdi-cart-plus',
					quando: 'Eseguito quando un prodotto viene aggiunto al carrello.',
					variabili: ['PRODUCT_ID', 'PRODUCT_NAME', 'PRODUCT_PRICE', 'PRODUCT_SKU', 'VARIANT_ID', 'QUANTITY', 'CURRENCY'],
					esempio:
						"Es: <script>gtag('event', 'add_to_cart', { currency: '{{CURRENCY}}', value: {{PRODUCT_PRICE}}, items: [{ item_id: '{{PRODUCT_ID}}', item_name: '{{PRODUCT_NAME}}', price: {{PRODUCT_PRICE}}, quantity: {{QUANTITY}} }] });<\/script>",
				},
				{
					key: 'buy',
					label: 'Acquisto',
					icona: 'mdi-cash-check',
					quando: 'Eseguito nella pagina di conferma ordine.',
					variabili: ['ORDER_ID', 'ORDER_TOTAL', 'ORDER_SUBTOTAL', 'ORDER_TAX', 'ORDER_SHIPPING', 'ORDER_CURRENCY', 'ORDER_ITEMS'],
					esempio:
						"Es: <script>gtag('event', 'purchase', { transaction_id: '{{ORDER_ID}}', value: {{ORDER_TOTAL}}, tax: {{ORDER_TAX}}, shipping: {{ORDER_SHIPPING}}, currency: '{{ORDER_CURRENCY}}', items: {{ORDER_ITEMS}} });<\/script>",
				},
				{
					key: 'signup',
					label: 'Registrazione',
					icona: 'mdi-account-plus-outline',
					quando: 'Eseguito dopo la registrazione di un nuovo utente.',
					variabili: ['USER_EMAIL', 'USER_NAME', 'USER_SURNAME'],
					esempio: "Es: <script>gtag('event', 'sign_up', { method: 'email' });<\/script>",
				},
				{
					key: 'newsletters',
					label: 'Iscrizione newsletter',
					icona: 'mdi-email-plus-outline',
					quando: "Eseguito dopo l'iscrizione alla newsletter.",
					variabili: ['EMAIL'],
					esempio: "Es: <script>gtag('event', 'generate_lead', { email: '{{EMAIL}}' });<\/script>",
				},
			],
		};
	},
	methods: {
		pieno(key) {
			return !!String((this.form.layout.script && this.form.layout.script[key]) || '').trim();
		},
		graffe(v) {
			return `{{${v}}}`;
		},
	},
};
</script>

<style scoped>
.sa-panels {
	border: 1px solid #e1e7ef;
	border-radius: 10px;
	overflow: hidden;
}
.sa-panel + .sa-panel {
	border-top: 1px solid #eef2f7;
}
.sa-panel::before {
	box-shadow: none !important;
}
.sa-header {
	min-height: 48px !important;
	padding: 8px 14px;
}
.sa-title {
	font-size: 14px;
	font-weight: 600;
	color: #1f2d3d;
}
.sa-help {
	font-size: 13px;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.sa-vars {
	font-size: 12px;
	color: #5f6b7a;
	margin-bottom: 8px;
	line-height: 1.9;
}
.sa-var {
	margin-left: 4px;
	font-size: 11px;
}
.sa-code ::v-deep textarea {
	font-family: monospace;
	font-size: 12px;
	line-height: 1.5;
}
</style>
